import { Controller } from "@hotwired/stimulus"

const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*\d).{6,}$/

export default class extends Controller {
  static targets = ["newPassword", "confirmPassword", "submitButton", "errorMessage"]

  static values = {
    emptyError: String,
    formatError: String,
    matchError: String
  }

  validate() {
    const password = this.newPasswordTarget.value || ""
    const confirm = this.confirmPasswordTarget.value || ""
    let error = ""

    if (!password || !confirm) {
      error = this.emptyErrorValue
    }

    else if (!PASSWORD_REGEX.test(password)) {
      error = this.formatErrorValue
    }

    else if (password !== confirm) {
      error = this.matchErrorValue
    }

    if (error) {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.classList.add("disabled")
      this.errorMessageTarget.textContent = error
    } else {
      this.submitButtonTarget.disabled = false
      this.submitButtonTarget.classList.remove("disabled")
      this.errorMessageTarget.textContent = ""
    }
  }
}